import styled from 'styled-components';
import { Typ51, Typ70 } from 'dc/Typ';
import Btn021 from 'dc/Btn021';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: transparent;
  text-align: center;
  width: 100%;
  margin-bottom: 37px;
`;

export const Title = styled(Typ51)`
  margin-bottom: 40px;
  width: 300px;
`;

export const Emoji = styled(Typ70)`
  margin-bottom: 30px;
`;

export const Button = styled(Btn021)`
  height: 36px;
  padding: 0 46px;
`;
